import type { ReactNode } from 'react';

import { useDesignVersion } from '../../context/useDesignVersion';
import LegacyThemeProvider from '../LegacyThemeProvider/LegacyThemeProvider';

export default function DesignThemeProvider({ children }: { children: ReactNode }) {
  const { isModernDesign } = useDesignVersion();
  if (isModernDesign) return children;
  return <LegacyThemeProvider>{children}</LegacyThemeProvider>;
}
